// eslint-disable-next-line no-use-before-define
import React from 'react';
import { ErrorCircleFill } from 'shared-components/images';
import { styled } from '@mui/system';
import { getCareplanStatusColor, getCareplanStatusTextColor } from './common';
import { CAREPLAN_STATUS } from 'op-pages/RO/Careplan/Common';

interface StyleProps {
  status: string;
}

const StyledStatusBubble = styled('div')<StyleProps>`
  align-self: center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  min-width: 22px;
  background-color: ${(props: StyleProps) => getCareplanStatusColor(props.status)};
  border: 2px solid ${(props: StyleProps) => getCareplanStatusColor(props.status)};
  // Inner text
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: ${(props: StyleProps) => getCareplanStatusTextColor(props.status)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const WarningIcon = styled(ErrorCircleFill)`
  position: absolute;
  left: 9px;
  top: -10px;
  width: 18px;
  height: 18px;
`;

interface props {
  status: string;
  hasUnsubmittedChanges?: any;
}

export const CareplanStatusBubble = ({ status, hasUnsubmittedChanges }: props): JSX.Element => {
  return (
    <StyledStatusBubble status={status}>
      {statusAbbreviations(status)}
      {hasUnsubmittedChanges && <WarningIcon />}
    </StyledStatusBubble>
  );
};

const statusAbbreviations = (status: string): string => {
  if (status === CAREPLAN_STATUS.dxSubmitted) {
    return 'Dx';
  }
  const statusArray = status.split('_');
  let statusLettersOnly = '';

  statusArray.map((item: string): string => (statusLettersOnly += item.charAt(0)));
  return statusLettersOnly.toUpperCase();
};
